import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

type PlanTitle =
  | "basic"
  | "comprehensive"
  | "signature"
  | "essentials"
  | "classic"
  | "deluxe";

type SingleMoreDetailsProps = Readonly<{
  onClick: (index: number) => void;
  index: number;
}>;

type MoreDetailsProps = Readonly<{
  onClick: (index: number) => void;
  compData: CompDataType;
}>;

type CompDataType = Record<string, { title: PlanTitle }>;
function SingleMoreDetails({ onClick, index }: SingleMoreDetailsProps) {
  const { t } = useWizardTranslation();

  return (
    <div className="flex-1 pb-spacing-s">
      <LabelButtonWrapper
        hierarchy="tertiary"
        label={t("see_more_details", "See more details")}
        className="text-[12px] font-body-font font-[600] h-[17px] px-0"
        onClick={() => onClick(index)}
      />
    </div>
  );
}

export default function MoreDetails({ onClick, compData }: MoreDetailsProps) {
  return (
    <div className="flex flex-row">
      {Object.entries(compData).map(([key], index) => (
        <SingleMoreDetails key={key} index={index} onClick={onClick} />
      ))}
    </div>
  );
}
